import { NgModule } from '@angular/core';
import { CommonModule, DatePipe, TitleCasePipe } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SentenceCasePipe } from './pipes/sentence-case.pipe';
import { CustomTranslateService } from './services/custom-translate.service';

@NgModule({
  declarations: [SentenceCasePipe],
  imports: [CommonModule, RouterModule],
  exports: [SentenceCasePipe],
  providers: [CustomTranslateService, TitleCasePipe, SentenceCasePipe, DatePipe],
})
export class CoreModule {}
